export const BASE_BOX_SHADOW = '0 1px 0 0 rgba(0, 0, 0, 0.05)';
export const TRANSPARENT_BOX_SHADOW = '0 1px 0 0 rgba(0, 0, 0, 0)';
